import ListCalendarGroups from '@/modules/calendars/views/ListCalendarGroups.vue'
import CreateCalendarGroup from './views/CreateCalendarGroup.vue'
import CalendarGroupDetail from './views/CalendarGroupDetail.vue'
import HomeLayout from '@/layouts/Home.vue'

export const calendarRoutes = [
  {
    path: '/payrollsConfig/:id/calendarGroups',
    name: 'calendarGroups',
    component: ListCalendarGroups,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarGroups/add',
    name: 'createCalendarGroup',
    component: CreateCalendarGroup,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarGroups/detail/:calendarGroupId',
    name: 'calendarGroupDetail',
    component: CalendarGroupDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
